import { Component, Input } from '@angular/core';

@Component({
  selector: 'eo-form-help-msg',
  templateUrl: './eo-form-help-msg.component.html',
  styleUrl: './eo-form-help-msg.component.scss',
})
export class EoFormHelpMsgComponent {
  @Input() formId?: string;
  @Input() help?: string;
}
